import { gql } from "graphql.macro";

export const HOSPITALITY_REQUEST = gql`
  mutation submitHospitalityRequest($input: HospitalityRequestInput) {
    submitHospitalityRequest(input: $input)
  }
`;
